(() => {
  const root = window.Shopify?.routes?.root || '/';
  const productPath = `${root}products/r36s-retro-handheld-game-console-3-5-inch-ips-screen-64gb-128gb-256gb-portable-gaming-device-with-built-in-games`;
  const currency = window.Shopify?.currency?.active || 'AUD';
  const money = (cents) => (Number(cents || 0) / 100).toLocaleString('en-AU', {
    style: 'currency',
    currency
  });

  const menuButton = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.main-nav');
  menuButton?.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  const openDrawer = () => {
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.hidden = false;
  };
  const closeDrawer = () => {
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.hidden = true;
  };

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openDrawer));
  document.querySelector('[data-cart-close]')?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  async function refreshCart(shouldOpen = false) {
    try {
      const cart = await fetch(`${root}cart.js`).then((response) => response.json());
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = cart.item_count;
      });
      const items = document.querySelector('[data-cart-items]');
      const footer = document.querySelector('[data-cart-footer]');
      if (!items) return;
      if (!cart.items.length) {
        items.innerHTML = `<div class="drawer-empty"><p>Your cart is empty.</p><a class="button button--lime" href="${productPath}">SHOP THE CONSOLE →</a></div>`;
        if (footer) footer.hidden = true;
      } else {
        items.innerHTML = cart.items.map((item) => `
          <div class="drawer-line">
            <img src="${item.image || ''}" alt="">
            <div>
              <b>${item.product_title}</b>
              <p>${item.variant_title === 'Default Title' ? '' : item.variant_title}</p>
              <span>Qty ${item.quantity}</span>
            </div>
            <strong>${money(item.final_line_price)}</strong>
          </div>
        `).join('');
        if (footer) footer.hidden = false;
        const total = document.querySelector('[data-cart-total]');
        if (total) total.textContent = money(cart.total_price);
        const addAnother = document.querySelector('[data-cart-add-another]');
        if (addAnother && cart.items[0]) addAnother.dataset.variantId = cart.items[0].variant_id;
      }
      if (shouldOpen) openDrawer();
    } catch (error) {
      console.warn('Could not refresh cart', error);
    }
  }

  document.querySelector('[data-cart-add-another]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    if (!button.dataset.variantId || button.disabled) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(button.dataset.variantId), quantity: 1 })
      });
      if (!response.ok) throw new Error('Cart request failed');
      await refreshCart(false);
      button.textContent = 'Added ✓';
    } catch (error) {
      button.textContent = 'Try again';
    } finally {
      setTimeout(() => { button.disabled = false; button.textContent = 'Add one +'; }, 1100);
    }
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const thumbs = [...section.querySelectorAll('[data-media-target]')];
    const media = [...section.querySelectorAll('[data-media-id]')];
    const activateMedia = (id) => {
      thumbs.forEach((element) => element.classList.remove('is-active'));
      media.forEach((element) => element.classList.remove('is-active'));
      section.querySelector(`[data-media-target="${id}"]`)?.classList.add('is-active');
      section.querySelector(`[data-media-id="${id}"]`)?.classList.add('is-active');
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => activateMedia(thumb.dataset.mediaTarget)));

    const form = section.querySelector('[data-product-form]');
    if (!form) return;
    const json = document.querySelector('[data-product-json]');
    const variants = json ? JSON.parse(json.textContent) : [];
    const selects = [...form.querySelectorAll('[data-option-index]')];
    const idInput = form.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-compare-price]');
    const availability = section.querySelector('[data-availability]');
    const addButton = form.querySelector('[data-add-button]');
    const addLabel = form.querySelector('[data-add-label]');
    const quantity = form.querySelector('[data-quantity]');
    const swatches = [...form.querySelectorAll('[data-swatch-option]')];
    const bundles = [...form.querySelectorAll('[data-bundle-qty]')];
    let selectedVariant = variants.find((variant) => String(variant.id) === idInput?.value) || variants[0];

    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value) - 1);
    });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      quantity.value = Number(quantity.value) + 1;
    });

    const updateBundlePrices = (variant) => {
      if (!variant) return;
      form.querySelectorAll('[data-bundle-qty]').forEach((bundle) => {
        const qty = Number(bundle.dataset.bundleQty);
        const discount = Number(bundle.dataset.bundleDiscount || 0);
        const unitPrice = Math.round(variant.price * (100 - discount) / 100);
        const compareUnit = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
        const unit = bundle.querySelector('[data-bundle-unit]');
        const total = bundle.querySelector('[data-bundle-total]');
        const compareTotal = bundle.querySelector('[data-bundle-compare]');
        if (unit) unit.textContent = money(unitPrice);
        if (total) total.textContent = money(unitPrice * qty);
        if (compareTotal) compareTotal.textContent = money(compareUnit * qty);
      });
    };

    swatches.forEach((swatch) => swatch.addEventListener('click', () => {
      const optionIndex = Number(swatch.dataset.swatchOption);
      const select = selects.find((element) => Number(element.dataset.optionIndex) === optionIndex);
      if (!select) return;
      select.value = swatch.dataset.swatchValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }));

    bundles.forEach((bundle) => bundle.addEventListener('click', () => {
      bundles.forEach((element) => {
        const active = element === bundle;
        element.classList.toggle('is-active', active);
        element.setAttribute('aria-pressed', String(active));
      });
      quantity.value = bundle.dataset.bundleQty;
    }));

    const updateVariant = () => {
      const selected = selects.map((select) => select.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
      selects.forEach((select) => {
        const output = select.previousElementSibling?.querySelector('[data-option-label]');
        if (output) output.textContent = select.value;
      });
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = 'UNAVAILABLE';
        return;
      }
      selectedVariant = variant;
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      document.querySelectorAll('[data-sticky-price]').forEach((element) => {
        element.textContent = money(variant.price);
      });
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
      }
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      if (availability) availability.textContent = variant.available ? 'In stock and ready to order' : 'Currently unavailable';
      swatches.forEach((swatch) => {
        const active = selected[Number(swatch.dataset.swatchOption)] === swatch.dataset.swatchValue;
        swatch.classList.toggle('is-active', active);
        swatch.setAttribute('aria-pressed', String(active));
      });
      updateBundlePrices(variant);
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId) activateMedia(String(mediaId));
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };

    selects.forEach((select) => select.addEventListener('change', updateVariant));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (addButton.disabled) return;
      addButton.disabled = true;
      addLabel.textContent = 'ADDING…';
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart request failed');
        await refreshCart(true);
        addLabel.textContent = 'ADDED ✓';
      } catch (error) {
        addLabel.textContent = 'TRY AGAIN';
      } finally {
        setTimeout(() => {
          addButton.disabled = false;
          addLabel.textContent = 'ADD TO CART';
        }, 1100);
      }
    });

    document.querySelector('[data-sticky-submit]')?.addEventListener('click', () => form.requestSubmit());
    const sticky = document.querySelector('[data-sticky-buy]');
    if (sticky && addButton) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.1 });
      observer.observe(addButton);
    }
    updateBundlePrices(selectedVariant);
  });

  document.querySelectorAll('[data-game-finder]').forEach((section) => {
    const input = section.querySelector('[data-game-search]');
    const cards = [...section.querySelectorAll('[data-game-result]')];
    const empty = section.querySelector('[data-game-empty]');
    input?.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const match = !query || card.dataset.search.includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
    });
  });

  document.querySelectorAll('[data-reviews]').forEach((section) => {
    const filters = [...section.querySelectorAll('[data-review-filter]')];
    const cards = [...section.querySelectorAll('[data-review-card]')];
    filters.forEach((filter) => filter.addEventListener('click', () => {
      filters.forEach((button) => button.classList.toggle('is-active', button === filter));
      const value = filter.dataset.reviewFilter;
      cards.forEach((card) => { card.hidden = value !== 'all' && !card.dataset.reviewCategory.split(' ').includes(value); });
    }));
  });

  document.querySelectorAll('[data-genre]').forEach((button) => button.addEventListener('click', () => {
    document.querySelectorAll('[data-genre]').forEach((element) => element.classList.remove('is-active'));
    button.classList.add('is-active');
  }));

  refreshCart(false);
})();
